









import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RouteNames } from '@/router'
import { sendAnalyticEvent, AnalyticsEvent } from '@/helpers/analytics'

import type { RawLocation } from 'vue-router'
import type { UserFull } from '@/models/users'

interface Data {
  link: RawLocation
}

interface Computed {
  getMe: UserFull
}

export default Vue.extend<Data, {}, Computed, {}>({
  data() {
    return {
      link: {
        name: RouteNames.App
      }
    }
  },
  computed: {
    ...mapGetters(['getMe']),
  },
  mounted() {
    const { score } = this.$route.params

    if (score) {
      sendAnalyticEvent<string>(AnalyticsEvent.USER_RATING, { additionalData: score, user: this.getMe })
    }
  },
  metaInfo() {
    return { title: this.$tc('rating.title') }
  },
})
